import React from "react"
import PlatformSelector from "./PlatformSelector"
import Value from "aldoo-ra/Value"
import useSitePlatform from "./useSitePlatform"
import AndroidHome from "./IndexPage/AndroidHome"
import IosHome from "./IndexPage/IosHome"
import WindowsHome from "./IndexPage/WindowsHome"

const homeComponents = {
  android: AndroidHome,
  ios: IosHome,
  windows: WindowsHome,
}

const IndexPage = () => {
  // the server's platform until hydrated, then the visitor's (useSitePlatform)
  const [platform] = useSitePlatform()
  const [isTransitioning] = Value("page_transition")
  const Home = homeComponents[platform]

  return (
    <div className="relative">
      {/* <PlatformSelector /> */}
      <div
        className={`transition-opacity duration-300 ${
          isTransitioning ? "opacity-0" : "opacity-100"
        }`}
      >
        {Home && <Home />}
      </div>
    </div>
  )
}

export default IndexPage